export const importImage = (img: string) => {
  // Simply return the public path
  return `/${img}`;
};